import { GrandImage, type GrandImageProps } from 'ui'
import starIcon from './ai-stars.svg'

type AihubStarIconProps = Partial<GrandImageProps>

export const AihubStarIcon = (props: AihubStarIconProps) => {
  return <GrandImage src={starIcon} alt="aihub-star-icon" {...props} />
}
